import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import api, { HomeFeedAiSection } from '@/services/api'

export const setAiVideoSections = createAction<HomeFeedAiSection[]>('aiVideo/setSections')
export const setAiVideoStatus = createAction<'idle' | 'loading' | 'loaded' | 'error'>(
  'aiVideo/setStatus',
)

export const loadAiVideoSections = createAsyncThunk<void, void>(
  'aiVideo/load',
  async (_, { dispatch }) => {
    dispatch(setAiVideoStatus('loading'))
    try {
      const sections = await api.getAiVideoSections()
      dispatch(setAiVideoSections(sections))
      dispatch(setAiVideoStatus('loaded'))
    } catch (err) {
      console.error('Failed to load AI-video sections:', err)
      dispatch(setAiVideoStatus('error'))
    }
  },
)
